import * as angular from 'angular';

import './styling.scss';
import * as template from './template.html';

import * as componentsModule from './components';
import * as auth0 from 'auth0-js';
import { AuthenticationService } from 'services/authentication';
import { CurrentUserService } from 'services/currentUser';
import { LoggingService } from 'services/logging';
import { NavigationService } from 'services/navigation';
import { UsSpinnerService } from 'common/source/types/angular-spinner';
import { ITimeoutService } from 'angular';

import { FlagshipService } from 'services/flagship';
import { checkFeatureFlagAndRedirect } from 'utilities/featureFlags';

const module = angular.module('login-page', [componentsModule.module.name]);

interface LoginPageController extends angular.IStrictController {
    attemptedLogin?: boolean;
    loginAttemptSucceeded?: boolean;
    loginAttemptFailed?: boolean;
    notACustomer?: boolean;
    unknownLoginError?: boolean;

    hasLoginError(): boolean;
}

module.component('loginPage', {
    template: template,
    bindings: {},
    /* tslint:disable:parameters-max-number */
    controller: function(
        this: LoginPageController,
        $element: angular.IAugmentedJQuery,
        $window: angular.IWindowService,
        loggingService: LoggingService,
        authenticationService: AuthenticationService,
        currentUserService: CurrentUserService,
        navigationService: NavigationService,
        usSpinnerService: UsSpinnerService,
        $timeout: ITimeoutService,
        flagshipService: FlagshipService,
        $scope: angular.IScope
    ) {
        this.hasLoginError = () => {
            return !!(this.loginAttemptFailed || this.notACustomer || this.unknownLoginError);
        };

        this.$onInit = () => {

            const checkFeatureFlag = () => {
                checkFeatureFlagAndRedirect('ReactLoginPage', flagshipService, $window);
            };

            const auth0Config = authenticationService.getAuth0Config();

            const webAuth = new auth0.WebAuth(auth0Config);

            const $ctrl = this;

            function startSpinner() {
                $timeout(() => {
                    usSpinnerService.spin('content-loading-spinner');
                });
            }

            function stopSpinner() {
                $timeout(() => {
                    usSpinnerService.stop('content-loading-spinner');
                });
            }

            if (currentUserService.isLoggedIn()) {
                startSpinner();
                currentUserService.verifyAuthentication().then(
                    function success() {
                        stopSpinner();
                        navigationService.toPoliciesPage();
                    },
                    function error(response) {
                        stopSpinner();
                        authenticationService.forgetAuthenticationToken();
                    }
                );
            }

            flagshipService.getCampaigns();

            if (flagshipService.getFeatureFlagStatus() === 'FeatureFlagStatus:Ready') {
                checkFeatureFlag();
            } else {
                $scope.$on('FeatureFlagStatus:Ready', () => {
                    checkFeatureFlag();
                });
            }

            if (window.location.hash) {
                $ctrl.attemptedLogin = true;
                startSpinner();

                webAuth.parseHash({ hash: window.location.hash }, function(parseError, authResult) {
                    if (authResult && authResult.idToken) {
                        const idToken: string = authResult.idToken;

                        authenticationService.setIsAuthenticating(true);
                        authenticationService.setAuthenticationToken(idToken);

                        currentUserService.verifyAuthentication().then(
                            function success() {
                                $ctrl.loginAttemptSucceeded = true;
                                stopSpinner();
                                const redirectUrl = $window.localStorage.getItem('redirect_url');
                                if (redirectUrl) {
                                    $window.localStorage.removeItem('redirect_url');
                                    $window.location.href = redirectUrl;
                                    return;
                                }
                                authenticationService.setIsAuthenticating(false);
                                navigationService.toPoliciesPage();
                            },
                            function error(response) {
                                if (response.status === 401) {
                                    $ctrl.notACustomer = true;
                                } else {
                                    $ctrl.unknownLoginError = true;
                                }

                                stopSpinner();
                                authenticationService.setIsAuthenticating(false);
                                authenticationService.forgetAuthenticationToken();
                            }
                        );
                    } else {
                        $ctrl.loginAttemptFailed = true; // bad or expired login link
                        stopSpinner();
                        authenticationService.setIsAuthenticating(false);
                        authenticationService.logout();
                    }
                });
            }
        };
    }
});

export { module };
